/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupChecklistsRoutingModule } from './builder-setup-checklists-routing.module';
import { ChecklistsExportToOfficeDialogComponent } from './components/checklists-export-to-office-dialog/checklists-export-to-office-dialog.component';
import { ChecklistsListComponent } from './components/checklists-list/checklists-list.component';
import { ChecklistsBusinessService } from './resources';
import {
  ChecklistsDetailComponent,
  ChecklistsDetailTopFormComponent,
  ChecklistsDetailElementsComponent,
  ChecklistsDetailItemsComponent,
} from './components/checklists-detail';
import { CoreUiExtSplitPaneModule } from '@gh/core-ui-ext/split-pane';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { CoreUiExtTreeModule } from '@gh/core-ui-ext/tree';

@NgModule({
            imports: [
              DragDropModule,
              BuilderSharedModule.forChild(),
              BuilderSetupChecklistsRoutingModule,
              CoreUiExtSplitPaneModule,
              TreeModule,
              CoreUiExtTreeModule,
            ],
            providers: [
              ChecklistsBusinessService,
            ],
            declarations: [
              ChecklistsExportToOfficeDialogComponent,
              ChecklistsListComponent,
              ChecklistsDetailComponent,
              ChecklistsDetailTopFormComponent,
              ChecklistsDetailElementsComponent,
              ChecklistsDetailItemsComponent,
            ],
          })
export class BuilderSetupChecklistsModule {
}
